import {Form} from "antd";
import React, {useEffect} from "react";
import DG_Form from "../../../../custom/data-entry/form";
import Content from "../../customer/content";
import {addCustomer} from "../../../../api/customer";
import uuid from "react-uuid";

const Add = ({onLoading, list, onCustomers, onCancel}) => {

    const [form] = Form.useForm()
    const key = uuid()
    const onFinish = (value) => {
        onLoading(true)
        addCustomer(value).then(r =>{
            onCustomers(r)
            onCancel()
            onLoading(false)
        })
            .catch(ex=>{
                onLoading(false)
            })
    }

    useEffect(()=>{
        form.setFieldsValue({key : key})
    },[])

    return (
        <>
            <DG_Form
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content list={list} form={form}/>

            </DG_Form>
        </>
    )
}

export default Add
